import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import getAny from 'utils/accessors/getAny.util';

import { DELETE_STYLIST_FAILURE, DELETE_STYLIST_REQUEST, DELETE_STYLIST_SUCCESS } from 'onboarding/stylists/actions';

const deleteStylist = (options) => {
  const salonId = getAny(null, 'salonId', options);
  const stylistId = getAny(null, 'stylistId', options);

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/${salonId}/stylist/${stylistId}/`,
      authenticated: true,
      types: [DELETE_STYLIST_REQUEST, DELETE_STYLIST_SUCCESS, DELETE_STYLIST_FAILURE],
      config: {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      },
      params: {
        stylistId,
        salonId,
      },
    },
  };
};

// noinspection JSUnusedGlobalSymbols
export default deleteStylist;
